module.exports = __webpack_public_path__ + "media/cases-brand-tommee-lazyload-121.55181350.mp4";